import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';

const COMMENT_PAGE_SIZE = 10;

const CommentsWidget = ({
    comments = [],
    onAddComment,
    isCommenting
}) => {
    const [newComment, setNewComment] = useState("");
    const [commentPage, setCommentPage] = useState(1);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!newComment.trim()) return;

        // Call Dashboard handler with event AND the text directly
        if (onAddComment) {
            onAddComment(e, newComment);
        }
        setNewComment("");
    };

    const sortedComments = [...comments].sort((a, b) => {
        const dateA = new Date(a.createdAt || a.created_at || a.timestamp || 0);
        const dateB = new Date(b.createdAt || b.created_at || b.timestamp || 0);
        return dateB.getTime() - dateA.getTime();
    });

    const displayComments = sortedComments.slice(0, commentPage * COMMENT_PAGE_SIZE);
    const hasMore = comments.length > commentPage * COMMENT_PAGE_SIZE;

    return (
        <div className="border border-slate-200 dark:border-slate-800 rounded-xl p-5 bg-white dark:bg-slate-900/70">
            <div className="flex items-center justify-between mb-3">
                <p className="text-sm font-semibold text-slate-900 dark:text-white">Comments</p>
                <span className="text-xs text-slate-500">
                    {comments.length} entr{comments.length === 1 ? "y" : "ies"}
                </span>
            </div>
            <form onSubmit={handleSubmit} className="space-y-3">
                <textarea
                    value={newComment}
                    onChange={(event) => setNewComment(event.target.value)}
                    rows={3}
                    placeholder="Add a note about conditions, follow-ups, or next steps..."
                    className="w-full bg-slate-100 dark:bg-slate-800 border border-slate-300 dark:border-slate-700 rounded-lg px-3 py-2 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:border-yellow-500 focus:outline-none text-sm"
                />
                <div className="flex justify-end">
                    <button
                        type="submit"
                        className="px-4 py-2 rounded-lg bg-yellow-600 text-white font-semibold hover:bg-yellow-500 transition-colors disabled:opacity-60 flex items-center gap-2"
                        disabled={!newComment.trim() || isCommenting}
                    >
                        {isCommenting && <Loader2 className="w-4 h-4 animate-spin" />}
                        {isCommenting ? "Posting..." : "Add Comment"}
                    </button>
                </div>
            </form>
            <div className="mt-4 space-y-2">
                {comments.length > 0 ? (
                    <>
                        {displayComments.map((comment, index) => (
                            <div key={`${comment.createdAt || comment.created_at || index}-${index}`} className="bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-lg px-3 py-2">
                                <p className="text-slate-700 dark:text-slate-200 text-sm">{comment.text}</p>
                                <p className="text-xs text-slate-500 mt-1">
                                    {comment.author || 'Unknown'} • {(() => {
                                        const dateStr = comment.createdAt || comment.created_at || comment.timestamp;
                                        if (!dateStr) return 'Just now';
                                        const date = new Date(dateStr);
                                        return isNaN(date.getTime()) ? 'Just now' : date.toLocaleString();
                                    })()}
                                </p>
                            </div>
                        ))}
                        {hasMore && (
                            <div className="flex justify-center">
                                <button
                                    onClick={() => setCommentPage((prev) => prev + 1)}
                                    className="px-3 py-1 rounded-lg border border-slate-300 dark:border-slate-700 text-slate-700 dark:text-slate-200 text-xs hover:border-yellow-500 transition-colors"
                                >
                                    Show more comments
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <p className="text-slate-500 text-sm">No comments yet.</p>
                )}
            </div>
        </div>
    );
};
export default CommentsWidget;
